import { AxiosError } from 'axios';
import dayjs from 'dayjs';

import { CandidateAiParsedCvType, CandidateAiSuggestionsType } from '../candidates/Candidates.types';

export type CandidateAiParsedCvError = {
  kind: 'candidate-unavailable' | 'provenance-mismatch' | 'unknown';
  message: string;
};

export const parsedCvProvenanceMismatchError: CandidateAiParsedCvError = {
  kind: 'provenance-mismatch',
  message: 'The parsed CV does not match the current suggestions.',
};

export const mapCandidateAiParsedCvError = (error: AxiosError): CandidateAiParsedCvError =>
  error.response?.status === 404
    ? { kind: 'candidate-unavailable', message: 'This candidate is no longer available.' }
    : { kind: 'unknown', message: 'Could not load the parsed CV.' };

export const hasParsedCvProvenanceMismatch = (
  aiSuggestions?: CandidateAiSuggestionsType | null,
  parsedCv?: CandidateAiParsedCvType | null
) => {
  if (!aiSuggestions?.hasSuggestions || !parsedCv) {
    return false;
  }

  const { cvUuid, cvHash } = aiSuggestions;
  if (!cvUuid && !cvHash) {
    return false;
  }

  return (!!cvUuid && cvUuid !== parsedCv.cvUuid) || (!!cvHash && cvHash !== parsedCv.cvHash);
};

export const formatParsedCvExtractedAt = (parsedAt?: number | null) => {
  if (!parsedAt) {
    return '';
  }

  const extractedAt = dayjs.unix(parsedAt);

  return extractedAt.isValid() ? extractedAt.format('D MMM YYYY, HH:mm') : '';
};
